<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="offset"
      :immediate-check="ischeck"
      finished-text="没有更多了"
      @load="loadMore"
    >
      <div class="recharge-list">
        <div class="van-hairline--bottom">
          <van-row gutter="10" class="thead">
            <van-col span="5">交易号</van-col>
            <van-col span="5">
              <div class="price">交易金额(元)</div>
            </van-col>
            <van-col span="4">
              <div>交易方式</div>
            </van-col>
            <van-col span="4">
              <div>交易状态</div>
            </van-col>
            <van-col span="5">
              <div class="date">交易时间</div>
            </van-col>
          </van-row>
        </div>
        <div class="van-hairline--bottom" v-for="(item,index) in dataList" :key="index">
          <van-row gutter="10" class="tbody">
            <van-col span="5">
              <div class="code">{{item.TransactionOrderlID}}</div>
            </van-col>
            <van-col span="5">
              <div class="price hlight">{{item.PayableMoney}}</div>
            </van-col>
            <van-col span="4">
              <div class="price hlight">{{getOnlinePaymentTypeText(item.LX_PayType)}}</div>
            </van-col>
            <van-col span="4">
              <div v-if="item.IsPromotion==null||!item.IsPromotion" style="color:red">失败</div>
              <div v-else style="color:green" >成功</div>
            </van-col>
            <van-col span="5">
              <div class="date">{{item.AddDatetime}}</div>
            </van-col>
          </van-row>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import command from '../../../tools/common'

export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var that = this;
      that.options = {
        type: "GetRechargeRecord",
        pageIndex: 1
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      that.$store.dispatch(this.options).then(
        res => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.TransactionOrderApiModelList.length <= 0) {
            that.finished = true;
          }
          if (this.options.pageIndex > 1) {
            if (res.TransactionOrderApiModelList.length > 0) {
              res.TransactionOrderApiModelList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = res.TransactionOrderApiModelList;
          }
        },
        error => {}
      );
    },
    getOnlinePaymentTypeText(status){
       return command.getOnlinePaymentTypeText(status);

    }
  }
};
</script>

<style scoped>
.recharge-list {
  background-color: #fff;
  overflow: hidden;
}
.recharge-list .tbody,
.recharge-list .thead {
  padding: 10px;
}
.recharge-list .thead {
  font-size: 13px;
  color: #888;
  padding-top: 20px;
}
.recharge-list .date {
  text-align: right;
}
.recharge-list .tbody .date {
  color: #999;
  font-size: 12px;
}
.recharge-list .price {
  text-align: center;
}
.recharge-list .tbody .price {
  font-size: 14px;
}
.recharge-list .tbody .code {
  font-size: 12px;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
}
</style>